import { Disclosure, Transition } from "@headlessui/react";
import React, { FC, Fragment } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandButton from "./expandButton";

interface ExpandRowProps {
  label?: string;
  defaultOpen?: boolean;
  keepOpen?: boolean;
}

const ExpandRow: FC<ExpandRowProps> = ({
  label,
  defaultOpen = false,
  keepOpen = false,
  children,
}) => {
  return (
    <Disclosure
      as="div"
      defaultOpen={defaultOpen}
      className="flex flex-col w-full"
    >
      {({ open }) => (
        <>
          <ExpandButton label={label} isOpen={open} keepOpen={keepOpen} />
          <Disclosure.Panel className="text-white sm:pt-16 md:pt-24">
            <Transition
              as="div"
              show={open}
              enter="transform transition duration-500"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transform duration-300 transition ease-in-out"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              {children}
            </Transition>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default ExpandRow;
